import { createRestApiClient } from '../index';
import { getUserToken } from '../../Utils/helper';

export const userDataFetcher = async (params, cookiesString, token) => {
  const restApiClient = createRestApiClient(false, true);
  const url = `api/fetchUserDetails?random=` + new Date().getTime();
  let errorApi = false;
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        authorization: token
          ? `Bearer ${token}`
          : cookiesString
            ? getUserTokenSSR(cookiesString)
            : getUserToken(true),
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      errorApi = true;
    });

  return data;
};
